import { AssetSubClassCode } from '@api/api/entity-constants';
import { Entity } from '@api/api/entity-schema';
import { groupedSubClassMap, TimeSeriesData } from '@api/api/timeseries-schema';
import { useQuery } from '@tanstack/react-query';
import { fetchSeriesHistory } from '@terminal/services/overview-widget/overview-widget-service';

export const isLongTail = (entity?: Pick<Entity, 'sub_class'>) =>
  !!entity && entity.sub_class !== AssetSubClassCode.EquityStock;

export const LEGACY_AO_DRAWER_SUB_CLASSES = new Set([
  ...groupedSubClassMap.fx,
  ...groupedSubClassMap.etfs,
  ...groupedSubClassMap.indexes,
  ...groupedSubClassMap.govBonds,
  ...groupedSubClassMap.commodities,
  AssetSubClassCode.EcoCentralBank,
]);

const hasAvailableSeries = (
  entity: Pick<Entity, 'tag' | 'default_snake'>,
  data?: TimeSeriesData
) =>
  data?.meta.entity === entity.tag && data.meta.snake === entity.default_snake;

export const useLongTailSeries = (entity: Entity) => {
  const queryKey = ['LONG_TAIL_SERIES', entity.tag, entity.default_snake];
  const result = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const response = await fetchSeriesHistory(entity.default_snake, signal);
      return hasAvailableSeries(entity, response);
    },
    enabled: !!entity.default_snake.trim(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return {
    isSeriesLoading: result.isLoading,
    entity: result.data ? entity : { ...entity, default_snake: '' },
  };
};
